import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/';
import axios from 'axios';

import Footer3 from '../Footer3';
import Header3 from '../Header3';
import PageBanner from '../PageBanner';
import bannerBg from '../../assets/img/page-banner.jpg';
import { FaDraftingCompass } from 'react-icons/fa';
// import AllSearch from '../SearchService/allSearch';
import SearchResultCard from '../SearchService/SearchResultCard';
import AllSearchResult from '../SearchService/AllSearchResult';
import "../SearchService/SearchService.css";
import { Helmet } from 'react-helmet';
import SideFilter from './SideFilter';


const SearchObj = {
    1: {
        type: 1,
        url: 'search all other ',
    },
    2: {
        type: 2,
        url: 'search_products',
    },
    3: {
        type: 3,
        url: 'search_methods',
    },
    4: {
        type: 4,
        url: 'search_subcategory',
    },
    5: {
        type: 5,
        url: 'search_test_methods',
    },
}

function isFilterEmpty(filters){
    return Object.values(filters).every((arr) => arr.length === 0);
}

// function to call get the products from api
async function  searchFunction(type, value, selected_filter = []) {
    let data = {};
  
    try {
        type = Number(type);

        if (!isFilterEmpty(selected_filter)){ // get product with filters

            data = await axios.get(`${process.env.REACT_APP_API_URL}search_product_with_filters`, {
                params: { filters: selected_filter,search: value },
            }).then((response) => response?.data?.data);
        }
        else if(type === 1){
            // get the products
            let products = await axios.get(`${process.env.REACT_APP_API_URL}${SearchObj[2].url}`, {
              params: { search: value },
            }).then((response) => response?.data?.data);
            // get the methods
            let test_standard = await axios.get(`${process.env.REACT_APP_API_URL}${SearchObj[3].url}`, {
                params: { search: value },
            }).then((response) => response?.data?.data);
            // get the subcategories
            let subcategory = await axios.get(`${process.env.REACT_APP_API_URL}${SearchObj[4].url}`, {
                params: { search: value },
            }).then((response) => response?.data?.data);
            let methods = await axios.get(`${process.env.REACT_APP_API_URL}${SearchObj[5].url}`, {
                params: { search: value },
            }).then((response) => response?.data?.data);

            // merge the data
            data = {products, test_standard, subcategory,methods};

        }
        else {
            data = await axios.get(`${process.env.REACT_APP_API_URL}${SearchObj[type].url}`, {
              params: { search: value },
            }).then((response) => response?.data?.data);
        }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return data;
}
  


// show the search result when user search for any product
const SearchPage = () => {
    
    const [results,setResults] =  useState(null);
    const [selectedFilters, setSelectedFilters] = useState({
        applicationUse: [],
        fiberType: [],
        industryServed: [],
        testProtocol: [],
    });


    // getting value from url
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const search = JSON.parse(searchParams.get('search'));

    const handleFilterChange = (category, id) => (e) => {
        const { checked } = e.target;

        setSelectedFilters((prev) => {
            const current = new Set(prev[category] || []);

            if (checked) {
            current.add(id);
            } else {
            current.delete(id);
            }

            return {
            ...prev,
            [category]: Array.from(current),
            };
        });
    };

    console.log(isFilterEmpty(selectedFilters));

    // console.log("")

    
    // useEffect to call the product api whenever search value from Url changes
    useEffect(() => {
        if (search.type && search.value) {
            const fetchData = async () => {
                const fetchedProducts = await searchFunction(search.type, search.value,selectedFilters);
                setResults(fetchedProducts);
            };
            fetchData();
        }
    }, [search.type, search.value,selectedFilters]);



    // console.log("results: ", results);
    // console.log("filters: ", filters);


    return(
        <>
            <Helmet>
                <title>{`Testfabrics.com: ${"search products, standards and methods".slice(0,60).toUpperCase()}`}</title>
            </Helmet>
            <Header3/>
            <PageBanner bannerBg={bannerBg} currentPage="Search" heading="Testfabric Search" />

            <div className='container pb-3' style={{minHeight:"50vh"}}>
                <div className='row justify-content-start align-items-start'>
                    <div className='col-lg-2 col-md-3 col-4 filter-sidebar mt-3'>
                        <div className='filter-container'>
                            <SideFilter selectedFilters={selectedFilters} handleFilterChange={handleFilterChange}/>
                            
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-9  col-8'>
                        
                        {
                            (Number(search.type) === 1 && isFilterEmpty(selectedFilters)) ?
                                <AllSearchResult searchResults={results} search={search} />
                            : results && results.length > 0 ?
                                results.map((data, index) => (
                                    <SearchResultCard
                                        key={data.product__ID}
                                        productId={data.product__ID}
                                        thumbnail={data.product__ID}
                                        defaultImg={process.env.REACT_APP_IMAGE_URL + 'images/product_testfabrics.jpg'}
                                        icon={<FaDraftingCompass />}
                                        heading={data.product__Name}
                                        text={data?.product__Description ? data.product__Description.slice(0, 95) + "..." : null}
                                        subheading={data?.product__Number}
                                        searchType={isFilterEmpty(selectedFilters) ? 2 : search.type}
                                    /> 
                                ))
                            : <div>No data found</div>
                        }
                    </div>
                    
                </div>
            </div>
 
            <Footer3/>
        </>
    );
}


export default SearchPage;